export default __webpack_public_path__ + "static/media/discoverArrow.b360bb86.svg";